/**
 * DFA — <dfa-avis-slider> (dfa-avis.js)
 * Contrôles prev/next du carrousel d'avis (scroll-snap natif).
 * Vanilla Web Component · listeners passifs · cleanup complet.
 */
(function () {
  if (customElements.get('dfa-avis-slider')) return;

  class DfaAvisSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dfa-avis__piste');
      this.prevBtn = this.querySelector('[data-avis-prev]');
      this.nextBtn = this.querySelector('[data-avis-next]');
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this.onPrev = () => this.slide(-1);
      this.onNext = () => this.slide(1);
      this.onScroll = () => this.requestUpdate();
      this.onResize = () => this.requestUpdate();

      this.prevBtn.addEventListener('click', this.onPrev);
      this.nextBtn.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.updateButtons();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.prevBtn.removeEventListener('click', this.onPrev);
      this.nextBtn.removeEventListener('click', this.onNext);
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    slide(direction) {
      const item = this.track.querySelector('.dfa-avis__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 24;
      const step = item.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    requestUpdate() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => this.updateButtons());
    }

    updateButtons() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const pos = this.track.scrollLeft;
      const scrollable = maxScroll > 4;
      this.prevBtn.disabled = !scrollable || pos <= 4;
      this.nextBtn.disabled = !scrollable || pos >= maxScroll - 4;
    }
  }

  customElements.define('dfa-avis-slider', DfaAvisSlider);
})();